const MickeyFloat = () => {
  return (
    <img
      src="/mickey.png"
      alt="Mickey"
      data-testid="mickey-float"
      className="fixed bottom-28 left-3 z-40 w-14 h-14 sm:w-16 sm:h-16 object-contain drop-shadow-[0_6px_14px_rgba(0,0,0,0.3)] hover:scale-110 transition-transform duration-300 pointer-events-none select-none animate-bounce"
      style={{ animationDuration: "2.8s" }}
    />
  );
};

export default MickeyFloat;
